import type { BoardColumn } from "../../../../lib/giftingRules";
import { KanbanCard } from "./KanbanCard";
import { WaitCard } from "./WaitCard";
import { cardInfo, type PipelineCtx } from "./model";

/** カンバン: 左端「1 リスト化」点線枠 ＋ 3列（交渉中／配送中／投稿・許諾） */
export function KanbanBoard({
  columns,
  listCount,
  ctx,
  selectedId,
  onOpen,
  onOpenSales,
}: {
  columns: BoardColumn[];
  listCount: number;
  ctx: PipelineCtx;
  selectedId: string | null;
  onOpen: (dealId: string) => void;
  onOpenSales: () => void;
}) {
  return (
    <div className="gf-board">
      <button type="button" className="gf-listbox" onClick={onOpenSales}>
        <span className="gf-listbox-title">
          <span className="gf-mono gf-listbox-no">1</span>リスト化
        </span>
        <span className="gf-listbox-count gf-mono">{listCount}</span>
        <span className="gf-listbox-desc">
          未打診のリストは営業タブの一覧で管理します。打診するとここから右の列に入ります。
        </span>
        <span className="gf-listbox-link">営業リストを開く</span>
      </button>
      {columns.map((col) => (
        <div className="gf-col" key={col.key}>
          <div className="gf-col-head">
            <span className="gf-col-title">
              <span className="gf-col-name">{col.name}</span>
              <span className="gf-col-sub">{col.sub}</span>
            </span>
            <span className="gf-col-badges">
              {col.act.length > 0 && <span className="gf-col-act">要対応 {col.act.length}</span>}
              <span className="gf-mono gf-col-count">{col.count}</span>
            </span>
          </div>
          {col.count === 0 && <div className="gf-col-empty">該当するエントリーはありません</div>}
          {col.act.map((c) => (
            <KanbanCard
              key={c.entry.id}
              card={c}
              info={cardInfo(c.entry, ctx)}
              selected={selectedId === c.entry.id}
              onOpen={() => onOpen(c.entry.id)}
            />
          ))}
          {col.wait.length > 0 && (
            <div className="gf-wait-group">
              <span className="gf-wait-label">
                {col.waitLabel} {col.wait.length}件
              </span>
              {col.wait.map((c) => (
                <WaitCard
                  key={c.entry.id}
                  card={c}
                  info={cardInfo(c.entry, ctx)}
                  selected={selectedId === c.entry.id}
                  onOpen={() => onOpen(c.entry.id)}
                />
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
